import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateMonth'
})
export class DateMonthPipe implements PipeTransform {

  transform(value: Date | string | null): string {
    if (!value) {
      return '';
    }
    const date = new Date(value);
    const monthNames = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} de ${month} de ${year}`;
  }

}
